<template>
    <div class="row">
        <LoadingSpinner v-if="isLoading" />
        <div class="col-12" v-if="!isLoading">
            <table class="table align-middle" v-if="calls.length > 0">
                <thead>
                    <tr>
                        <th>{{ $t("lang.elevenlab.date-time") }}</th>
                        <th v-if="!fromPipe">Booker</th>
                        <th>Audio</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="call in calls" :key="call.id">
                        <td>{{ formatDate(call.created) }}</td>
                        <td v-if="!fromPipe">{{ bookerName  }}</td>
                        <td>
                            <audio controls v-if="call.audio">
                                <source :src="audioFormatUrl(call.audio.audio_base64)" type="audio/mpeg">
                            </audio>
                            <span v-else class="text-muted">{{ $t("lang.elevenlab.no-calls") }}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div>
                <p v-if="calls.length === 0" class="text-muted">{{ $t("lang.elevenlab.no-calls") }}</p>
            </div>
                
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { bookersService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

export default {
    name: "UserTestRolePlay",
    components: { LoadingSpinner },
    data() {
        return {
            calls: [],
            loadingHistory: false,
            fullName: "",
            isLoading: false,
            bookerName:''
        };
    },
      computed: {
    ...mapState({
      // loading: (state) => state.users.loading,
      currentUser: (state) => state.authentication.user,
    }),
    ...mapState({
      headerTab: (state) => state.header.tab,
    }),
    disabled: function () {
      if (this.amount != "" && this.amount > 0 && this.amount <= 500) {
        return true;
      }
    },
    user() {
      return this.$store.state.authentication.user;
    },
    Page() {
      this.$route.fullPath == "/users"
        ? this.changeHeaderTab({ tab: "ALL" })
        : "";
      return;
    },
    isOptionSelected() {
      return (value) => {
        const idOptionSelected = this.options.find(
          (el) => el.selected == true && el.name === value
        );
        if (idOptionSelected) {
          return idOptionSelected.name === value ? true : false;
        } else {
          return false;
        }
      };
    },
  },
    props: {
        loading: Boolean,
        selected: Object,
        selectedUserId: {
            type: [Number, String],
            required: true
        },
        fromPipe: {
          type: Boolean,
          default: false,
        }
    },
    created() {
        this.isLoading = !!this.loading;
        this.fetchCalls();
        console.log(this.selected)
        let fullName = `${this.selected.user.name || ""} ${this.selected.user.lastname || ""}`;
        this.bookerName = fullName
    },
    watch: {
        loading(newVal) {
            this.isLoading = !!newVal;
        }
    },
    methods: {
        // método de formateo definido explícitamente (sintaxis corta)
        formatDate(iso) {
            if (!iso) return "—";
            try {
                return new Intl.DateTimeFormat("fr-FR", {
                    timeZone: "Europe/Paris",
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit"
                }).format(new Date(iso));
            } catch (e) {
                return iso;
            }
        },
 audioFormatUrl: function (base) {
      let audio = "data:audio/mp3;base64," + (base || "");
      return audio;
    },
        // fetchCalls con sintaxis moderna
        async fetchCalls() {
            if (this.calls.length === 0) this.loadingHistory = true;
            try {
               let data = {
                  bdr_user_id: this.selectedUserId,
                }
                this.isLoading = true;
                const calls = await bookersService.getElevenLabsCalls(data);
                this.calls = calls.conversation || calls.conversations || [];
            } catch (e) {
                console.error("fetchCalls error:", e);
            } finally {
                this.loadingHistory = false;
                this.isLoading = false;
            }
        }
    }
};
</script>